import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaArrowCircleLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function Toolbar({ showBackBtn, title, forceTitleCenter = false, forceShowBack = false, overrideBack = null }) {
  const navigate = useNavigate();

  const backClicked = () => {
    if (overrideBack) {
      overrideBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div style={{ height: "5rem" }} className={`block w-full flex justify-between ${forceTitleCenter ? "" : "md:justify-start"} items-center p-4 mb-5`}>
      <FontAwesomeIcon icon={faChevronCircleLeft} visibility={showBackBtn ? "block" : "hidden"} className={`cursor-pointer ${forceShowBack ? "" : "md:hidden"}`} size={"2xl"} onClick={backClicked} />
      <span className="h4 m-0 text-center font-medium text-xl md:ms-5">{title}</span>
      <FaArrowCircleLeft visibility={"hidden"} style={{ fontSize: "2rem" }} />
    </div>
  );
}

export default Toolbar;
